import React, { useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { ReactComponent as TrashIcon } from "assets/icons/Bredcrum_Icon/infoIcon.svg";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { getIcon } from "utils/iconsConfig";
import { ReactComponent as Ring } from "assets/icons/Ring.svg";
import { ReactComponent as OtherMaterial } from "assets/icons/OtherMaterial.svg";
import SmallImage from "./SmallImage";
import ViewMessageModal from "./ClientFlow/UiModal/ViewMessageModal";
import ClientFlowInfoDetailsModal from "./ClientFlow/UiModal/ClientFlowInfoDetailsModal";
import { useLocation } from "react-router-dom";
import ImageModal from "./ImageModal";
import Tooltip from "./Tooltip";

const PurchaseCard = ({ data, allData }) => {
  const location = useLocation();
  const showTrue = Boolean(location.state?.Wip) || Boolean(location?.state?.Orders);

  const cardStyle = {
    display: "flex",
    alignItems: "start",
    justifyContent: "space-between",
    backgroundColor: "#0C0C0C",
    border: "1px solid #C0C0C0",
    borderRadius: "10px",
    padding: "10px",
    color: "#FFFFFF",
    maxWidth: "370px",
    minWidth: "370px ",
    transition: "all 0.3s ease",
  };

  const infoSectionStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: Object.keys(data).length >= 9 && showTrue ? "12px" : "22px",
    fontSize: "14px",
    fontWeight: 500,
  };

  const iconTextRow = {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "11px",
    fontWeight: 400,
    fontFamily: "Poppins",
    lineHeight: "100%",
    whiteSpace: "nowrap",
  };

  const dividerStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    justifyContent: "center",
    margin: "0 10px 0px 0px",
    cursor: "pointer",
  };

  const imageContainerStyle = {
    width: "188px",
    height: "188px",
    borderRadius: "4.59px",
    overflow: "hidden",
    border: "1px solid #3D3D3D",
    // pointerEvents: "none"
  };

  const imageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "fit",
    transition: "transform 0.3s ease",
  };

  const [openMessageModal, setOpenMessageModal] = useState(false);
  const [openInfoModal, setOpenInfoModal] = useState(false);

  const handleOpenMessage = () => setOpenMessageModal(true);
  const handleCloseMessage = () => setOpenMessageModal(false);

  const handleOpenInfo = () => setOpenInfoModal(true);
  const handleCloseInfo = () => setOpenInfoModal(false);
  const [imageModal, setImageModal] = useState({ isOpen: false, imgUrl: null, designNo: null });
  const [currentIndex, setCurrentIndex] = useState(null);
  const isFirstItem = currentIndex === 0;
  const isLastItem = currentIndex === allData?.length - 1 || allData?.length === 0;

  const handleOpenImageModal = React.useCallback(
    (imgUrl, designNo) => {
      setImageModal({ isOpen: true, imgUrl, designNo });
      let newIndex = allData?.findIndex((item) => (item?.StyleCode || item?.styleNo) == designNo);
      setCurrentIndex(newIndex);
    },
    [data]
  );

  const handleCloseImageModal = React.useCallback((e) => {
    e.stopPropagation();
    setImageModal({ isOpen: false, imgUrl: null, designNo: null });
    setCurrentIndex(currentIndex);
  }, []);

  const handleNextClick = () => {
    if (currentIndex < allData?.length - 1) {
      const newIndex = currentIndex + 1;
      setCurrentIndex(newIndex);
      const nextItem = allData[newIndex];
      setImageModal((prev) => ({
        ...prev,
        isOpen: true,
        imgUrl: nextItem?.ImageUrl || nextItem?.imageUrl ? nextItem?.ImageUrl || nextItem?.imageUrl : null,
        designNo: nextItem?.StyleCode || nextItem?.styleNo,
      }));
    }
  };

  const handlePrevClick = () => {
    if (currentIndex > 0) {
      const newIndex = currentIndex - 1;
      setCurrentIndex(newIndex);
      const prevItem = allData[newIndex];

      setImageModal((prev) => ({
        ...prev,
        isOpen: true,
        imgUrl: prevItem?.ImageUrl || prevItem?.imageUrl ? prevItem?.ImageUrl || prevItem?.imageUrl : null,
        designNo: prevItem?.StyleCode || prevItem?.styleNo,
      }));
    }
  };

  return (
    <div style={cardStyle}>
      {/* Left Info Section */}
      <div style={infoSectionStyle}>
        {data?.orderNo && (
          <div style={iconTextRow}>
            <span role="img" aria-label="diamond">
              {getIcon("RedBag", "white")}
            </span>
            <span>{data.orderNo}</span>
          </div>
        )}

        {data?.styleNo && (
          <div style={iconTextRow}>
            <span role="img" aria-label="clock">
              <Ring width={"12px"} height={"12px"} />
            </span>
            <span>{data.styleNo}</span>
          </div>
        )}

        {data?.orderRef && (
          <div style={iconTextRow}>
            <span role="img" aria-label="doc">
              {getIcon("OrderNote_Icon", "white")}
            </span>
            <span>{data.orderRef}</span>
          </div>
        )}

        {data?.location && (
          <div style={iconTextRow}>
            {getIcon("Location_Icon", "white")}
            {/* <span>{data.location}</span> */}
            <Tooltip title={data?.location} marginTop="2px">
            <span
              style={{
                maxWidth: "120px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline-block",
                verticalAlign: "middle",
                cursor: "default"
              }}
              // title={data.location}
            >
              {data.location}
            </span>
            </Tooltip>
          </div>
        )}

        {data?.department && (
          <div style={{ ...iconTextRow, marginLeft: "2px" }}>
            {getIcon("Department_Icon", "white")}
            <span>{data.department}</span>
          </div>
        )}

        {data?.quality && (
          <div style={iconTextRow}>
            <span role="img" aria-label="box">
              <OtherMaterial width={"13px"} height={"13px"} />
            </span>
            <span>{data.quality}</span>
          </div>
        )}

        <div style={{ ...iconTextRow, marginLeft: "2px" }}>
          {getIcon("Message_Icon", "white")}
          <span
            style={{
              textDecoration: "underline",
              cursor: "pointer",
            }}
            onClick={handleOpenMessage}
          >
            View messages
          </span>
          <ViewMessageModal open={openMessageModal} onClose={handleCloseMessage} data={data} />
        </div>

        {data?.messageDate && (
          <div style={{ ...iconTextRow, marginLeft: "2px" }}>
            {getIcon("Grey_Date_Icon")}
            <span>{data.messageDate}</span>
          </div>
        )}

        {data?.dueDate && (
          <div style={{ ...iconTextRow, marginLeft: "2px", color: "#50C878" }}>
            {getIcon("Green_Date_Icon")}
            <span>{data.dueDate}</span>
          </div>
        )}
      </div>

      {/* Divider with Info Icon */}
      <div style={dividerStyle}>
        <TrashIcon style={{ width: "15px", height: "15px" }} onClick={handleOpenInfo} />

        <ClientFlowInfoDetailsModal open={openInfoModal} onClose={handleCloseInfo} data={data} />
      </div>

      {/* Right Image */}
      <div style={imageContainerStyle}>
        {/* <img src={data.transformedImageUrl} alt="jewelry" style={imageStyle} /> */}
        <SmallImage data={data} handleOpenImageModal={handleOpenImageModal} hasAccessToSeeWatermark={true} />
      </div>

      <ImageModal
        open={imageModal.isOpen}
        handleClose={handleCloseImageModal}
        data={imageModal}
        hasAccessToSeeWatermark={true}
        nextClick={() => handleNextClick()}
        prevClick={() => handlePrevClick()}
        hasNext={!isLastItem}
        hasPrev={!isFirstItem}
        selectedCartProducts={allData?.[currentIndex] ?? null}
      />
    </div>
  );
};

export default PurchaseCard;
